<template>
  <div class="control_bar top">
    <controller
      :dispItems="dispItems"
      :allItems="template"
      :router="router"
      @remove="remove"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      showFinishModal: false,
      finishWord: '',
      router: '/template/add',
      showloadingModal: false
    }
  },
  computed: {
    template() {
      return this.$store.state.template.template
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedTemplateList() {
      return this.$store.state.template.selectedTemplateList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedTemplateIdList = this.selectedTemplateList.map(
        template => template.id
      )
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'template/deleteTemplates',
          selectedTemplateIdList
        )
        this.$store.dispatch('template/clearSelectedTemplateList')
        this.finishWord = '対象の定型文を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/template') {
          this.$router.push('/template')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_710001
        let eventType = 3
        let reason = 'MSGCRC0310'
        if (error.response) {
          this.finishWord =
            this.errorMsg.MSGCRC0310.name +
            this.errorMsg.MSGCRC0310.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.controller >>> .uploader,
.controller >>> .txt,
.controller >>> .column_import,
.controller >>> .column_export {
  color: #bbb;
  pointer-events: none;
}
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/template/controlbar.vue